import './refs';
import './checkForLoginState';
import './footerModal';
import './inputSearch';
import './movieModal';
import './modalLogIn';
import './modalSignUp';
import './renderMovieModal';
import './renderMovies';
import './renderTrendingFilms';
import './trailer';
import './watchedLS';
import './queueLS';
import './sliderTopMovie';
